// 官方例子
import Vue from 'vue';
import {
  Form,
  FormItem,
  Radio,
  Button,
  Input,
  Dialog,
  CheckboxButton,
  Checkbox,
  CheckboxGroup,
  CascaderPanel,
  Cascader,
  Loading,
  Alert,
  Message,
  Result
} from 'element-ui';

Vue.use(Input);
Vue.use(Radio);
Vue.use(Dialog);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(CheckboxButton);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Loading);
Vue.use(Cascader);
Vue.use(CascaderPanel);
Vue.use(Button);
Vue.use(Result)

Vue.prototype.$message = Message;
Vue.prototype.$alert = Alert;



// WEBPACK FOOTER //
// ./src/auto-import-elementUI.js